import style from './loader.module.css';
export const Loader = () => {

    return (

        <span class={style.loader}></span>

    );
};